module.exports = __webpack_public_path__ + "static/media/hat-santa.f55fcbca.svg";